import { z } from 'zod';
import { commissioningRecalculationRunStatusSchema, commissioningThresholdAxisSchema } from './commissioning-threshold-state';

/** Technical intent, not a commercial event or an economic result. The source
 * identity comes from an immutable informational state committed with it. */
export const commissioningThresholdInvalidationContextSchema = z.object({
  schemaVersion: z.literal(1),
  source: z.object({
    stateId: z.string().uuid(),
    competitionId: z.string().uuid(),
    instanceId: z.string().uuid(),
    memberId: z.string().uuid(),
    periodId: z.string().uuid(),
    axis: commissioningThresholdAxisSchema,
    revision: z.string().regex(/^[a-f0-9]{64}$/),
  }).strict(),
}).strict();
export type CommissioningThresholdInvalidationContext =
  z.infer<typeof commissioningThresholdInvalidationContextSchema>;

export const commissioningThresholdInvalidationReportSchema = z.object({
  schemaVersion: z.literal(1),
  message: z.string().min(1),
  runIds: z.array(z.string().uuid()),
}).strict();
export type CommissioningThresholdInvalidationReport =
  z.infer<typeof commissioningThresholdInvalidationReportSchema>;

export const commissioningThresholdInvalidationRecordSchema = z.object({
  id: z.string().uuid(),
  context: commissioningThresholdInvalidationContextSchema,
  status: commissioningRecalculationRunStatusSchema,
  report: commissioningThresholdInvalidationReportSchema.nullable(),
  createdAt: z.string().datetime({ offset: true }),
  completedAt: z.string().datetime({ offset: true }).nullable(),
}).strict();
export type CommissioningThresholdInvalidationRecord =
  z.infer<typeof commissioningThresholdInvalidationRecordSchema>;

export const commissioningThresholdInvalidationJobSchema = z.object({
  type: z.literal('invalidate-threshold-dependents'),
  tenantId: z.string().uuid(),
  runId: z.string().uuid(),
}).strict();
export type CommissioningThresholdInvalidationJob =
  z.infer<typeof commissioningThresholdInvalidationJobSchema>;
